/*
We use this component when we need to grab a value from a select2 field and
apply it in other field. We need to use the class
SELECT2_TARGET_ELEMENT_CLASS on the select2 and pass some information in the
data attribute.
Data attributes:
  1. Targets (required)(array): elements that will receive the selected values.
  2. TargetsValueIdentifier (required)(array): the name of the attribute that
  will be used in the target[index]. For example: "text", "id"
*/
import { Controller } from "stimulus";

const SELECT2_TARGET_ELEMENT_CLASS = ".select2-linked-input-text";

export default class extends Controller {
  connect() {
    $(SELECT2_TARGET_ELEMENT_CLASS).on("select2:select", function (e) {
      let {
        params: { data },
      } = e;
      let { targets, targetsValueIdentifier } = this.dataset;

      // we receive as strings, so we have to convert to array
      targets = JSON.parse(targets);
      targetsValueIdentifier = JSON.parse(targetsValueIdentifier);

      targets.forEach((target, index) => {
        const targetValue = data[targetsValueIdentifier[index]];
        document.getElementById(target).value = targetValue;
      });
    });
  }

  resetSelect(e) {
    const {
      currentTarget: {
        dataset: { target },
      },
    } = e;
    const $targetElement = $(`${SELECT2_TARGET_ELEMENT_CLASS}.${target}`);
    $targetElement.val(null).trigger("change");
  }
}
